import { useState, useEffect } from "react";

const BASE_STATS = [
  { icon: "ri-ship-2-line", label: "Containers Shipped Today", base: 18472, increment: 1, suffix: "" },
  { icon: "ri-user-3-line", label: "Active Buyers Online", base: 2341890, increment: 7, suffix: "" },
  { icon: "ri-building-4-line", label: "Factories Online Now", base: 847320, increment: 3, suffix: "" },
  { icon: "ri-exchange-dollar-line", label: "Trade Value Today (USD)", base: 9820000000, increment: 50000, suffix: "$", isUSD: true },
];

function formatNum(n: number, isUSD?: boolean): string {
  if (isUSD) {
    if (n >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)}B`;
    if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
    return `$${n.toLocaleString()}`;
  }
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toLocaleString();
}

export default function GoldStatsBar() {
  const [counts, setCounts] = useState(BASE_STATS.map(s => s.base));

  useEffect(() => {
    const interval = setInterval(() => {
      setCounts(prev =>
        prev.map((val, i) => val + BASE_STATS[i].increment * (1 + Math.floor(Math.random() * 3)))
      );
    }, 1800);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="w-full py-0"
      style={{ background: "linear-gradient(90deg, #92400e 0%, #b45309 25%, #d97706 50%, #b45309 75%, #92400e 100%)" }}
    >
      {/* Top shimmer line */}
      <div className="w-full h-0.5" style={{ background: "linear-gradient(90deg, transparent, #fde68a, #fbbf24, #fde68a, transparent)" }}></div>

      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-0">

          {/* Brand label */}
          <div className="flex items-center gap-2 shrink-0 sm:pr-6 sm:border-r sm:border-amber-600">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20">
              <i className="ri-global-line text-white text-sm"></i>
            </div>
            <div>
              <p className="text-white font-extrabold text-xs leading-none tracking-widest uppercase">Crown Global</p>
              <p className="text-amber-200 text-[10px] leading-none mt-0.5">Live Trade Stats</p>
            </div>
            {/* Live dot */}
            <span className="flex items-center gap-1 bg-white/15 border border-white/25 text-white text-[10px] font-bold px-2 py-0.5 rounded-full ml-1">
              <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse inline-block"></span>
              LIVE
            </span>
          </div>

          {/* Stats */}
          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-0 sm:divide-x sm:divide-amber-600/50">
            {BASE_STATS.map((s, i) => (
              <div key={s.label} className="flex items-center gap-2.5 px-4 py-1">
                <div className="w-8 h-8 flex items-center justify-center bg-white/15 rounded-lg shrink-0">
                  <i className={`${s.icon} text-amber-200 text-base`}></i>
                </div>
                <div className="min-w-0">
                  <div className="text-white font-extrabold text-base leading-tight tabular-nums">
                    {formatNum(counts[i], s.isUSD)}
                  </div>
                  <div className="text-amber-200 text-[10px] leading-tight truncate">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom shimmer line */}
      <div className="w-full h-0.5" style={{ background: "linear-gradient(90deg, transparent, #fde68a, #fbbf24, #fde68a, transparent)" }}></div>
    </section>
  );
}
